import type { CardPresentation } from '../../types/feedContract'
import { useI18n } from '../../i18n'

interface CardEditorialProps {
  presentation: CardPresentation
}

export function CardEditorial({ presentation }: CardEditorialProps) {
  const { t } = useI18n()
  const hasTitle = Boolean(presentation.eyebrow || presentation.headline || presentation.badge)
  if (!hasTitle && !presentation.rationale) return null

  return (
    <div className="card-editorial">
      <div className="card-editorial-kicker">
        {presentation.badge ? (
          <span className="card-editorial-badge">{presentation.badge}</span>
        ) : null}
        {presentation.eyebrow ? (
          <span className="card-editorial-eyebrow">{presentation.eyebrow}</span>
        ) : null}
      </div>
      {presentation.headline ? (
        <h2 className="card-editorial-headline">{presentation.headline}</h2>
      ) : null}
      {presentation.rationale ? (
        <details
          className="card-editorial-rationale"
          open={presentation.variant === 'spotlight'}
        >
          <summary>{t('parlay.why')}</summary>
          <p>{presentation.rationale}</p>
        </details>
      ) : null}
    </div>
  )
}
